export default "<div class=\"d-inline-block maxWidth\">\n  <img [src]=\"image\" />\n\n  <p class=\"text-center\">{{ text }}</p>\n</div>\n";